import { render } from "./ScrollUp.vue?vue&type=template&id=279ec88a&scoped=true"
import script from "./ScrollUp.vue?vue&type=script&lang=js"
export * from "./ScrollUp.vue?vue&type=script&lang=js"

import "./ScrollUp.vue?vue&type=style&index=0&id=279ec88a&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279ec88a"]])

export default __exports__